<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import FileList from '@/domains/investor/components/FileList/FileList.vue'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorIncentiveProgrammes.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorIncentiveProgrammes.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorIncentiveProgrammes.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorIncentiveProgrammes.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorIncentiveProgrammes.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorIncentiveProgrammes.canonical.pl'),
    },
  ],
}))
</script>

<template>
  <div>
    <InvestorHero
      :title="$t('investor.incentiveProgrammes.hero.title')"
      :lead="$t('investor.incentiveProgrammes.hero.lead')"
      image="/images/investor/hero/incentive-programmes.png"
      :first-button="{
        text: $t('investor.incentiveProgrammes.hero.firstButton.label'),
        to: $t('investor.incentiveProgrammes.hero.firstButton.to'),
      }"
    />

    <UiSection
      :id="$t('investor.incentiveProgrammes.sectionId')"
      class="incentive-programmes__section"
      color="white"
    >
      <UiHeader
        :header="$t('investor.incentiveProgrammes.hero.title')"
        :position="'center'"
        :header-size="'h5'"
        :header-size-tablet="'h5'"
        :header-size-mobile="'h5'"
      />

      <FileList
        request-id="lad-korporacyjny-programy-motywacyjne"
        :show-title="false"
        :file-item-options="{
          showFormat: true,
        }"
        :file-item-link-options="{label:t('investor.files.seeDocument')}"
      />

    </UiSection>
  </div>
</template>

